import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "recordType", 
    "operatorType", 
    "filesContainer", 
    "operatorTypeContainer", 
    "personalAddressContainer", 
    "personalAddressStreet",
    "personalAddressNumber",
    "personalAddressFloorNumber",
    "personalAddressMunicipality",
    "personalAddressPostalCode",
    "academicDegree"
  ];

  connect() {
    this.updateOperatorTypeOptions();

    if (this.hasOperatorTypeTarget || this.operatorTypeTarget.value) {
      this.operatorTypeChanged();
    }

    const infoLink = document.getElementById('data_processing_info');
    if (infoLink) {
      infoLink.addEventListener('click', this.toggleDataProcessingInfo);
    }
  }

  // Opcions del select de tipus d'operador segons el tipus de registre seleccionat
  updateOperatorTypeOptions() {
    const selectedRecordType = this.recordTypeTarget.value;
    let optionsToShow;
  
    const allOptions = {
      'Productor': 'Productor',
      'Elaborador': 'Elaborador',
      'Agrupacio': 'Agrupació',
      'Tecnic': 'Tècnic'
    };
    
    if (["1", "2", "3", "5", "6", "7"].includes(selectedRecordType)) {
      optionsToShow = allOptions;
    } else if (selectedRecordType === "4") {
      optionsToShow = { 'Productor': 'Productor', 'Elaborador': 'Elaborador' };
    } else {
      optionsToShow = {};
    }
  
    this.populateOperatorTypeOptions(optionsToShow);
    this.updateOperatorTypeContainerDisplay(Object.keys(optionsToShow).length > 0, selectedRecordType !== "7");
  }
  
  // Select de tipus d'operador amb les opcions corresponents
  populateOperatorTypeOptions(options) {
    if (this.hasOperatorTypeTarget) {
      const operatorTypeSelect = this.operatorTypeTarget;
      const selectedValue = operatorTypeSelect.value;

      operatorTypeSelect.options.length = 0;

      if (Object.keys(options).length > 0) {
        operatorTypeSelect.add(new Option('', '', true, true));

        Object.entries(options).forEach(([value, text]) => {
          operatorTypeSelect.add(new Option(text, value, value === selectedValue, value === selectedValue));
        });

        operatorTypeSelect.disabled = false;
        this.updateOperatorTypeContainerDisplay(true);
      } else {
        operatorTypeSelect.disabled = true;
        this.updateOperatorTypeContainerDisplay(false);
      }
    }
  }

  // Contenidor del select de tipus d'operador
  updateOperatorTypeContainerDisplay(show, required) {
    if (this.hasOperatorTypeContainerTarget) {
      this.operatorTypeContainerTarget.style.display = show ? '' : 'none';
      const operatorTypeElement = document.getElementById('operator_type');
      operatorTypeElement.required = required;
      if (!required) {
        operatorTypeElement.removeAttribute('required');
      }
    }
  }
  
  // Actualitzem camps, mostrem/amaguem dades segons el rol
  operatorTypeChanged() {
    const recordTypeId = this.recordTypeTarget.value;
    const operatorTypeId = this.operatorTypeTarget.value;
    const url = `/digital_registries/update_file_fields?record_type=${recordTypeId}&operator_type=${operatorTypeId}`;

    if (this.hasPersonalAddressContainerTarget) {
      const isTechnician = operatorTypeId === 'Tecnic';
      const form = this.element;
      const isAdminOrCcpi = form.dataset.adminOrCcpi === "true";
      const currentUserNif = form.dataset.userNif;
      this.personalAddressContainerTarget.style.display = isTechnician ? '' : 'none';

      if (this.hasPersonalAddressStreetTarget) {
        this.personalAddressStreetTarget.required = isTechnician;
      }
      if (this.hasPersonalAddressNumberTarget) {
        this.personalAddressNumberTarget.required = isTechnician;
      }
      if (this.hasPersonalAddressMunicipalityTarget) {
        this.personalAddressMunicipalityTarget.required = isTechnician;
      }
      if (this.hasPersonalAddressPostalCodeTarget) {
        this.personalAddressPostalCodeTarget.required = isTechnician;
      }
      if (this.hasAcademicDegreeTarget) {
        this.academicDegreeTarget.required = isTechnician;
      }

      // Actualitzem el camp NIF segons el tipus d'operador i el rol de l'usuari
      const nifInput = document.querySelector('#digital_registry_nif');
      if (nifInput && isTechnician && !isAdminOrCcpi) {
        if (currentUserNif) {
          nifInput.value = currentUserNif;
          nifInput.readOnly = true;
        }
      } else if (nifInput) {
        nifInput.readOnly = false;
      }
    }

    fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'text/html' }
    }).then(response => response.text())
      .then(html => {
        this.filesContainerTarget.innerHTML = html;
      });
  }

  // Informació sobre el tractament de dades personals
  toggleDataProcessingInfo(event) {
    event.preventDefault();
    const hiddenInfo = document.getElementById('hidden_info');
    if (hiddenInfo) {
      hiddenInfo.classList.toggle('hidden');
    }
  }
}
